<template>
  <div class="flex w-full justify-center">
    <RouterLink
      :data-tint="alreadySent ? 'task-status-2' : 'task-no-status'"
      :to="{
        name: dossier[field].route,
        params: { id: dossier?.dossier_redirect?.router.params.id }
      }"
      class="task-gradient squircle-md @container/task flex flex-1 cursor-pointer items-center justify-center rounded px-1 py-0.5"
    >
      <span class="@8xs/task:hidden block px-1 leading-5">
        <FontAwesomeIcon :icon="['fal', alreadySent ? 'check' : 'times']" />
      </span>
      <span
        class="@8xs/task:block hidden truncate font-semibold whitespace-nowrap"
      >
        {{ alreadySent ? $t('global.sent') : $t('global.not_sent') }}
      </span>
    </RouterLink>
  </div>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'PartnerColumnComponent',
  components: { FontAwesomeIcon },
  props: {
    column: {
      type: Object,
      required: true
    },
    dossier: {
      type: Object,
      required: true
    },
    field: {
      type: String,
      required: true
    }
  },
  computed: {
    alreadySent() {
      return !!this.dossier[this.field]?.value
    }
  }
}
</script>
